import angular from 'angular';

angular.module('cloudX').directive('cxToggleButton', [
  function() {
    return {
      restrict: 'E',
      replace: true,
      template: `<label class="react-toggle-wrapper margin5T">
      <div class="react-toggle"
           ng-class="{'react-toggle--checked':checked, 'react-toggle--disabled':disabled}">
        <div class="react-toggle-track">
          <div class="react-toggle-track-check">
            <svg width="14" height="11" viewBox="0 0 14 11">
              <path d="M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0" fill="#fff" fill-rule="evenodd"></path>
            </svg>
          </div>
          <div class="react-toggle-track-x">
            <svg width="10" height="10"viewBox="0 0 10 10">
              <path d="M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12" fill="#fff" fill-rule="evenodd"></path>
            </svg>
          </div>
        </div>
        <div class="react-toggle-thumb"></div>
        <input class="react-toggle-screenreader-only" ng-model="checked" ng-change="setValue()" ng-disabled="disabled" type="checkbox">
      </div>
      <span ng-bind="label"></span>
    </label>`,
      scope: {
        disabled: '=',
        label: '@',
      },
      require: 'ngModel',
      link: function($scope, el, attrs, ngModel) {
        if (!ngModel) return;
        $scope.setValue = function() {
          ngModel.$setViewValue(!!$scope.checked);
        };
        ngModel.$render = function() {
          $scope.checked = !!ngModel.$viewValue;
        };
      },
    };
  },
]);
